import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';
import { MenuItemModel } from '../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Quick Quiz',
    ImagePath: '/assets/images/landing/quick-quizzes.png',
    DestinationPage: 'Quick-Quiz',
  },
  {
    Text: 'Mistakes Quiz',
    ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
    DestinationPage: 'Mistakes-Quiz',
    MenuType: MenuItemTypeEnum.MistakesQuiz,
  },
  {
    Text: 'Flashcards',
    ImagePath: '/assets/images/landing/flashcards.png',
    DestinationPage: 'Flashcards',
  },
  {
    Text: 'Listening',
    ImagePath: '/assets/images/landing/practice-audio.png',
    DestinationPage: 'Listening',
  }
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a Quick Quiz',
    ButtonURL: 'quick-quiz',

    MixedOnlineTests: [
      {
        // URL Updated to point to the correct QuickQuiz data for ETR46 20260915
        MixedOnlineTestUrl: '_revisionhub_opc/ETR46/ETR46_QuickQuizzes_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Quick Quizzes',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Test yourself with quizzes covering every section. On your marks, get set... quiz!</p>' +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Last quiz score: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Questions on every section',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',

    MixedOnlineTests: [
      {
        // URL Updated to point to the correct MistakesQuiz data source for ETR46 20260915
        MixedOnlineTestUrl: '_revisionhub_opc/ETR46/ETR46_Mistakes_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>The quick quiz questions you got wrong are here  -  have another go and conquer them once and for all!</p>' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.QuotationFlashcards,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Flashcards',
    ButtonURL: 'flashcards',

    MixedOnlineTests: [
      {
        // URL Updated to point to the correct Flashcards data source for ETR46 20260915
        MixedOnlineTestUrl: '_revisionhub_opc/ETR46/ETR46_Flashcards_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: false,
    HeadingText: 'Flashcards',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Key quotes on the front and helpful analysis on the back.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Speedy on-the-go revision',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.ListeningTracks,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Listen now',
    ButtonURL: 'listening',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Audio Discussions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Listen to our experts chat about plot, characters, themes and more!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Key info and helpful analysis',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Audio Discussions',
      Intro:
                '<p>Let’s chat! Turn up your volume and choose the discussion you’d like to listen to.</p>',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [
        '[[cloudfront_url]]/_revisionhub_opc/ETR46/Audio/01-ETR46-audio-discussion-plot.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/ETR46/Audio/02-ETR46-audio-discussion-characters.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/ETR46/Audio/03-ETR46-audio-discussion-themes.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/ETR46/Audio/04-ETR46-audio-discussion-techniques.mp3',
      ],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    ButtonURL: 'extras',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Audio transcripts, a knowledge organiser, exam advice... yep, it\'s all right here.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      // TODO: populate ContentMain with intro text and ContentRight with an image if needed
      HeaderText: 'Extra Useful Bits',
      ContentMain: '<div class="free-content">' +
       //TODO: Check wording as same as above'<p>Audio transcripts, a knowledge organiser, exam advice... yep, it\'s all right here.</p>' +
        '<strong>' + 
        '<a href="[[cloudfront_url]]/_revisionhub_opc/ETR46/PDFs/cgp-gcse-romeo-and-juliet-audio-transcripts.pdf"><span style="color:#1494d4;">Audio Transcripts</span></a><br />' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/ETR46/PDFs/cgp-gcse-romeoandjuliet-exam-advice-aqa-ocr.pdf"><span style="color:#1494d4;">Exam Advice - AQA/OCR</span></a><br />' +
        '<a href="[[cloudfront_url]]/_revisionhub_opc/ETR46/PDFs/cgp-gcse-romeoandjuliet-exam-advice-edexcel.pdf"><span style="color:#1494d4;">Exam Advice - Edexcel</span></a><br />'+
        '<a href="[[cloudfront_url]]/_revisionhub_opc/ETR46/PDFs/cgp-gcse-romeoandjuliet-exam-advice-eduqas.pdf"><span style="color:#1494d4;">Exam Advice - Eduqas</span></a><br />'+
        '<a href="[[cloudfront_url]]/_revisionhub_opc/ETR46/PDFs/cgp-romeo-and-juliet-ko.pdf"><span style="color:#1494d4;">Knowledge Organiser</span></a>' +
        '</strong>' +
        '</div>',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},{
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Products',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Take a look at the FAQs if you need some help.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our FAQs',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text:
        '<h2>Frequently Asked Questions</h2>\n' +
      '<h5>What is CGP RevisionHub?</h5>\n' +
      '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE English Text Guide. Use the quizzes, flashcards and more to revise what you\'ve learned from your book and prepare for the exams.</p>\n' +
      '<h5>How do I access CGP RevisionHub?</h5>\n' +
      '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.</p>\n' +
      '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
      '<p>You\'ll notice lots of QR codes scattered throughout your book. Give them a scan and you\'ll automatically be taken to the relevant test, video or other revision thingy-ma-jig so you can go over what you\'ve learned!</p>\n' +
      '<h5>My CGP RevisionHub isn\'t working  —  what do I do?</h5>\n' +
      '<p>If you can\'t find the answer in these FAQs, it\'s time to contact our friendly Customer Services team. You could also ask your friendly neighbourhood psychic, but they will charge...</p>\n' +
      '<h5>Do I need an internet connection to use CGP RevisionHub?</h5>\n' +
      '<p>Yes, you do. But you can also download some handy PDF resources to use offline. Nice.</p>\n' +
      '<h5>If I log in on a different device, will all my progress be saved?</h5>\n' +
      '<p>Yep. Just log in on your computer, tablet or phone, and all your progress will be there waiting for you.</p>\n' +
      '<h5>Can I clear my progress so far in CGP RevisionHub and start again?</h5>\n' +
      '<p>There are no takie-backsies in CGP RevisionHub, so you can\'t clear your results and start again. But, you can have another go at any of the quizzes and they\'ll update to show your latest scores. Keep going, we believe in you!</p>\n' +
      '<h5>Can I share my test results with other people?</h5>\n' +
      '<p>You can\'t share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where\'s the fun in that?</p>\n' +
      '<h5>What happens when I\'ve answered all the questions?</h5>\n' +
      '<p>Ah, one of life\'s greatest questions  —  what next? We\'d recommend that you keep practising right up until your exams.</p>\n' +
      '<h5>Will I always have access to CGP RevisionHub?</h5>\n' +
      '<p>Once you activate the code in the front of your book, you\'ll have access for three years. And they\'ll be three whole years of bliss, we promise.</p>\n',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },},
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP Revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',

    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>There\'s plenty more revision where this came from! Take a look at some of our other revision books.</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },}
];